
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import PercentageStackedBarChart from '../chartjs/PercentageStackedBarChart.vue';
import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '../ChartError.vue';
import ChartLabels from '../ChartLabels.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data } from '../../models';
import { ChartType } from '../../models/chartType';
import shortid from 'shortid';

@Component({
	components: {
		BarChart,
		PercentageStackedBarChart,
		LineChart,
		LoadingSpinner,
		ChartError,
		ChartNoData,
		ChartLabels,
		FlowIcon,
		HelpIcon,
	},
})
export default class ConversationTrendCharts extends Vue {
	@Prop() public data!: Data;

	@Prop() public loadedData!: boolean;

	@Prop() public loadingError!: boolean;

	public reportId = '';

	public tooltipText = 'A trend showing the number of recently created conversations';

	public chartType: ChartType = ChartType.BAR;

	public created() {
		this.reportId = shortid.generate();
	}

	public get showLineChart() {
		return this.chartType === ChartType.LINE;
	}

	public get showBarChart() {
		return this.chartType === ChartType.BAR;
	}

	public switchLineChart() {
		this.chartType = ChartType.LINE;
	}

	public switchBarChart() {
		this.chartType = ChartType.BAR;
	}

	public get loadedAndNotReturnedData() {
		return this.loadedData && (!this.data || !this.data.series || this.data.series.length === 0);
	}

	public get loadedAndReturnedData() {
		return this.loadedData && this.data && this.data.series && this.data.series.length > 0;
	}
}
